<div class="tab-pane" role="tabpanel" id="caract_anteproyecto">
    <fieldset id="agregar_caract_anteproyecto" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Caracteristica de la solicitud</strong></h3>
                        <hr>
                        <div class="form-horizontal">
                            <div class="form-group" align="left" style="padding-bottom: 20px">
                                <div class="col-md-12" align="left">
                                    <h4><strong>Resoluci&oacute;n permiso</strong></h4>
                                </div>
                                <div class="col-md-2">
                                    <label for="agregar_caract_anteproyecto" style=" padding-top: 15px;" >N&uacute;mero:</label>
                                </div>
                                <div class="col-md-10">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Nº" id="num_reso_perm" name="num_reso_perm" formControlName="num_reso_perm" (change)="add_caract_solicitud()">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label class="control-label" for="fecha" style="padding-bottom: 20px; padding-top: 15px;">Fecha:</label>
                                </div>
                                <div class="col-md-10">
                                    <mat-form-field class="dateinput" style="width: 145px;">
                                        <input matInput [matDatepicker]="dp4" [max]="maxDate" formControlName="fecha_reso_perm" disabled (dateInput)="add_caract_solicitud($event, 'input')" (dateChange)="add_caract_solicitud($event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp4"></mat-datepicker-toggle>
                                        <mat-datepicker #dp4 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2">
                                    <label for="anteproy_aprob" >Tipo Garant&iacute;a</label>
                                </div>
                                <div class="col-md-10 inline">
                                    <mat-radio-group formControlName="tipo_garantia" (change)="add_caract_solicitud()">
                                        <mat-radio-button style="padding-right: 20px" name="tipo_garantia" value="SI">Garant&iacute;a parcial</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="tipo_garantia" value="NO">Garant&iacute;a total</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>